import { useSettings } from "../../data/content";

function NavLogo() {
  const { author } = useSettings();
  return <img src="/sbLogo.svg" alt={author} className="w-8 h-8 mr-2" />;
}

export default NavLogo;
